export class User {
  favorites: string[];

  constructor(
    public name: string,
    public uid: string
  ){}


}



// WEBPACK FOOTER //
// /Users/kaitlynfujihara/Desktop/keiken/src/app/user.model.ts